import { GET_CURRENT_ACCESS_TOKEN_COOKIE_ENDPOINT } from '@dtx-company/true-common/src/constants/endpoints'
import { logger } from '@dtx-company/logger'
import { notifyObserversOfLogin } from './notify'

export async function getCurrentAccessTokenCookie(shouldNotify = true): Promise<string | null> {
  try {
    const res = await fetch(GET_CURRENT_ACCESS_TOKEN_COOKIE_ENDPOINT, {
      method: 'GET',
      credentials: 'include'
    })
    if (!res.ok) {
      await logger.logFetchError(res, { technicalArea: 'authentication' })
    }
    const { accessToken } = (await res.json()) as { accessToken: string | null }
    if (shouldNotify && accessToken) {
      notifyObserversOfLogin(accessToken)
    }
    return accessToken
  } catch (e: unknown) {
    logger.logError(e, { technicalArea: 'authentication' })
    return null
  }
}
